/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateWellpassImportDTO } from '../dto';
// @ts-ignore
import { EnrichWellpassMembershipsDTO } from '../dto';
// @ts-ignore
import { ImportWellpassMembershipsDTO } from '../dto';
// @ts-ignore
import { UpdateWellpassSettingsDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
// @ts-ignore
import { WellpassImportDTO } from '../dto';
// @ts-ignore
import { WellpassImportDryRunResultDTO } from '../dto';
// @ts-ignore
import { WellpassListDTO } from '../dto';
// @ts-ignore
import { WellpassMembershipEnrichResponseDTO } from '../dto';
// @ts-ignore
import { WellpassMembershipImportResponseDTO } from '../dto';
// @ts-ignore
import { WellpassTransactionsHistoryDTO } from '../dto';
/**
 * WellpassApi - axios parameter creator
 * @export
 */
export const WellpassApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate Wellpass sync for a tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSync: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('activateSync', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/wellpass/settings/activateSync`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {EnrichWellpassMembershipsDTO} enrichWellpassMembershipsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrichMemberships: async (tenantId: string, enrichWellpassMembershipsDTO: EnrichWellpassMembershipsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('enrichMemberships', 'tenantId', tenantId)
            // verify required parameter 'enrichWellpassMembershipsDTO' is not null or undefined
            assertParamExists('enrichMemberships', 'enrichWellpassMembershipsDTO', enrichWellpassMembershipsDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/wellpass/import/enrich`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrichWellpassMembershipsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] Case-insensitive match against company name, company id, registration link, or budget (cents)
         * @param {boolean} [includeAlreadyConnected] Include already connected tenants
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportedList: async (search?: string, includeAlreadyConnected?: boolean, page?: number, pageSize?: number, sortBy?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/benefits/wellpass/external-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (includeAlreadyConnected !== undefined) {
                localVarQueryParameter['includeAlreadyConnected'] = includeAlreadyConnected;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory: async (tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTransactionHistory', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/wellpass/transactionHistory`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (withAggregations !== undefined) {
                localVarQueryParameter['withAggregations'] = withAggregations;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the wellpass company settings for a tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWellpassConfig: async (tenantId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getWellpassConfig', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/wellpass/settings`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ImportWellpassMembershipsDTO} importWellpassMembershipsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMemberships: async (tenantId: string, importWellpassMembershipsDTO: ImportWellpassMembershipsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('importMemberships', 'tenantId', tenantId)
            // verify required parameter 'importWellpassMembershipsDTO' is not null or undefined
            assertParamExists('importMemberships', 'importWellpassMembershipsDTO', importWellpassMembershipsDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/wellpass/import/memberships`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importWellpassMembershipsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CreateWellpassImportDTO>} createWellpassImportDTO 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importWellpassExcelList: async (createWellpassImportDTO: Array<CreateWellpassImportDTO>, dryRun?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWellpassImportDTO' is not null or undefined
            assertParamExists('importWellpassExcelList', 'createWellpassImportDTO', createWellpassImportDTO)
            const localVarPath = `/benefits/wellpass/external-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWellpassImportDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWellpassMembershipByTenant: async (tenantId: string, employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('syncWellpassMembershipByTenant', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('syncWellpassMembershipByTenant', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/wellpass/sync`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the settings for wellpass of a tenant
         * @param {string} tenantId 
         * @param {UpdateWellpassSettingsDTO} updateWellpassSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWellpassSettings: async (tenantId: string, updateWellpassSettingsDTO: UpdateWellpassSettingsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateWellpassSettings', 'tenantId', tenantId)
            // verify required parameter 'updateWellpassSettingsDTO' is not null or undefined
            assertParamExists('updateWellpassSettings', 'updateWellpassSettingsDTO', updateWellpassSettingsDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/wellpass/settings`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWellpassSettingsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WellpassApi - functional programming interface
 * @export
 */
export const WellpassApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WellpassApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate Wellpass sync for a tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateSync(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateSync(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {EnrichWellpassMembershipsDTO} enrichWellpassMembershipsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrichMemberships(tenantId: string, enrichWellpassMembershipsDTO: EnrichWellpassMembershipsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WellpassMembershipEnrichResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrichMemberships(tenantId, enrichWellpassMembershipsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [search] Case-insensitive match against company name, company id, registration link, or budget (cents)
         * @param {boolean} [includeAlreadyConnected] Include already connected tenants
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportedList(search?: string, includeAlreadyConnected?: boolean, page?: number, pageSize?: number, sortBy?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WellpassListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImportedList(search, includeAlreadyConnected, page, pageSize, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionHistory(tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WellpassTransactionsHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionHistory(tenantId, filter, withAggregations, sortBy, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the wellpass company settings for a tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWellpassConfig(tenantId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WellpassImportDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWellpassConfig(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ImportWellpassMembershipsDTO} importWellpassMembershipsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importMemberships(tenantId: string, importWellpassMembershipsDTO: ImportWellpassMembershipsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WellpassMembershipImportResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importMemberships(tenantId, importWellpassMembershipsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<CreateWellpassImportDTO>} createWellpassImportDTO 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importWellpassExcelList(createWellpassImportDTO: Array<CreateWellpassImportDTO>, dryRun?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WellpassImportDryRunResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importWellpassExcelList(createWellpassImportDTO, dryRun, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncWellpassMembershipByTenant(tenantId: string, employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncWellpassMembershipByTenant(tenantId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the settings for wellpass of a tenant
         * @param {string} tenantId 
         * @param {UpdateWellpassSettingsDTO} updateWellpassSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWellpassSettings(tenantId: string, updateWellpassSettingsDTO: UpdateWellpassSettingsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWellpassSettings(tenantId, updateWellpassSettingsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WellpassApi - factory interface
 * @export
 */
export const WellpassApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WellpassApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate Wellpass sync for a tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSync(tenantId: string, options?: any): AxiosPromise<void> {
            return localVarFp.activateSync(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {EnrichWellpassMembershipsDTO} enrichWellpassMembershipsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrichMemberships(tenantId: string, enrichWellpassMembershipsDTO: EnrichWellpassMembershipsDTO, options?: any): AxiosPromise<WellpassMembershipEnrichResponseDTO> {
            return localVarFp.enrichMemberships(tenantId, enrichWellpassMembershipsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] Case-insensitive match against company name, company id, registration link, or budget (cents)
         * @param {boolean} [includeAlreadyConnected] Include already connected tenants
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string>} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportedList(search?: string, includeAlreadyConnected?: boolean, page?: number, pageSize?: number, sortBy?: Array<string>, options?: any): AxiosPromise<WellpassListDTO> {
            return localVarFp.getImportedList(search, includeAlreadyConnected, page, pageSize, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory(tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: any): AxiosPromise<WellpassTransactionsHistoryDTO> {
            return localVarFp.getTransactionHistory(tenantId, filter, withAggregations, sortBy, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the wellpass company settings for a tenant
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWellpassConfig(tenantId: string, options?: any): AxiosPromise<WellpassImportDTO> {
            return localVarFp.getWellpassConfig(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {ImportWellpassMembershipsDTO} importWellpassMembershipsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMemberships(tenantId: string, importWellpassMembershipsDTO: ImportWellpassMembershipsDTO, options?: any): AxiosPromise<WellpassMembershipImportResponseDTO> {
            return localVarFp.importMemberships(tenantId, importWellpassMembershipsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<CreateWellpassImportDTO>} createWellpassImportDTO 
         * @param {boolean} [dryRun] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importWellpassExcelList(createWellpassImportDTO: Array<CreateWellpassImportDTO>, dryRun?: boolean, options?: any): AxiosPromise<WellpassImportDryRunResultDTO> {
            return localVarFp.importWellpassExcelList(createWellpassImportDTO, dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWellpassMembershipByTenant(tenantId: string, employeeId: string, options?: any): AxiosPromise<void> {
            return localVarFp.syncWellpassMembershipByTenant(tenantId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the settings for wellpass of a tenant
         * @param {string} tenantId 
         * @param {UpdateWellpassSettingsDTO} updateWellpassSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWellpassSettings(tenantId: string, updateWellpassSettingsDTO: UpdateWellpassSettingsDTO, options?: any): AxiosPromise<void> {
            return localVarFp.updateWellpassSettings(tenantId, updateWellpassSettingsDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateSync operation in WellpassApi.
 * @export
 * @interface WellpassApiActivateSyncRequest
 */
export interface WellpassApiActivateSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof WellpassApiActivateSync
     */
    readonly tenantId: string
}

/**
 * Request parameters for enrichMemberships operation in WellpassApi.
 * @export
 * @interface WellpassApiEnrichMembershipsRequest
 */
export interface WellpassApiEnrichMembershipsRequest {
    /**
     * 
     * @type {string}
     * @memberof WellpassApiEnrichMemberships
     */
    readonly tenantId: string

    /**
     * 
     * @type {EnrichWellpassMembershipsDTO}
     * @memberof WellpassApiEnrichMemberships
     */
    readonly enrichWellpassMembershipsDTO: EnrichWellpassMembershipsDTO
}

/**
 * Request parameters for getImportedList operation in WellpassApi.
 * @export
 * @interface WellpassApiGetImportedListRequest
 */
export interface WellpassApiGetImportedListRequest {
    /**
     * Case-insensitive match against company name, company id, registration link, or budget (cents)
     * @type {string}
     * @memberof WellpassApiGetImportedList
     */
    readonly search?: string

    /**
     * Include already connected tenants
     * @type {boolean}
     * @memberof WellpassApiGetImportedList
     */
    readonly includeAlreadyConnected?: boolean

    /**
     * 
     * @type {number}
     * @memberof WellpassApiGetImportedList
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof WellpassApiGetImportedList
     */
    readonly pageSize?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof WellpassApiGetImportedList
     */
    readonly sortBy?: Array<string>
}

/**
 * Request parameters for getTransactionHistory operation in WellpassApi.
 * @export
 * @interface WellpassApiGetTransactionHistoryRequest
 */
export interface WellpassApiGetTransactionHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof WellpassApiGetTransactionHistory
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof WellpassApiGetTransactionHistory
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof WellpassApiGetTransactionHistory
     */
    readonly withAggregations?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof WellpassApiGetTransactionHistory
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof WellpassApiGetTransactionHistory
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof WellpassApiGetTransactionHistory
     */
    readonly pageSize?: number
}

/**
 * Request parameters for getWellpassConfig operation in WellpassApi.
 * @export
 * @interface WellpassApiGetWellpassConfigRequest
 */
export interface WellpassApiGetWellpassConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof WellpassApiGetWellpassConfig
     */
    readonly tenantId: string
}

/**
 * Request parameters for importMemberships operation in WellpassApi.
 * @export
 * @interface WellpassApiImportMembershipsRequest
 */
export interface WellpassApiImportMembershipsRequest {
    /**
     * 
     * @type {string}
     * @memberof WellpassApiImportMemberships
     */
    readonly tenantId: string

    /**
     * 
     * @type {ImportWellpassMembershipsDTO}
     * @memberof WellpassApiImportMemberships
     */
    readonly importWellpassMembershipsDTO: ImportWellpassMembershipsDTO
}

/**
 * Request parameters for importWellpassExcelList operation in WellpassApi.
 * @export
 * @interface WellpassApiImportWellpassExcelListRequest
 */
export interface WellpassApiImportWellpassExcelListRequest {
    /**
     * 
     * @type {Array<CreateWellpassImportDTO>}
     * @memberof WellpassApiImportWellpassExcelList
     */
    readonly createWellpassImportDTO: Array<CreateWellpassImportDTO>

    /**
     * 
     * @type {boolean}
     * @memberof WellpassApiImportWellpassExcelList
     */
    readonly dryRun?: boolean
}

/**
 * Request parameters for syncWellpassMembershipByTenant operation in WellpassApi.
 * @export
 * @interface WellpassApiSyncWellpassMembershipByTenantRequest
 */
export interface WellpassApiSyncWellpassMembershipByTenantRequest {
    /**
     * 
     * @type {string}
     * @memberof WellpassApiSyncWellpassMembershipByTenant
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof WellpassApiSyncWellpassMembershipByTenant
     */
    readonly employeeId: string
}

/**
 * Request parameters for updateWellpassSettings operation in WellpassApi.
 * @export
 * @interface WellpassApiUpdateWellpassSettingsRequest
 */
export interface WellpassApiUpdateWellpassSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof WellpassApiUpdateWellpassSettings
     */
    readonly tenantId: string

    /**
     * 
     * @type {UpdateWellpassSettingsDTO}
     * @memberof WellpassApiUpdateWellpassSettings
     */
    readonly updateWellpassSettingsDTO: UpdateWellpassSettingsDTO
}

/**
 * WellpassApi - object-oriented interface
 * @export
 * @class WellpassApi
 * @extends {BaseAPI}
 */
export class WellpassApi extends BaseAPI {
    /**
     * 
     * @summary Activate Wellpass sync for a tenant
     * @param {WellpassApiActivateSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WellpassApi
     */
    public activateSync(requestParameters: WellpassApiActivateSyncRequest, options?: AxiosRequestConfig) {
        return WellpassApiFp(this.configuration).activateSync(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WellpassApiEnrichMembershipsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WellpassApi
     */
    public enrichMemberships(requestParameters: WellpassApiEnrichMembershipsRequest, options?: AxiosRequestConfig) {
        return WellpassApiFp(this.configuration).enrichMemberships(requestParameters.tenantId, requestParameters.enrichWellpassMembershipsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WellpassApiGetImportedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WellpassApi
     */
    public getImportedList(requestParameters: WellpassApiGetImportedListRequest = {}, options?: AxiosRequestConfig) {
        return WellpassApiFp(this.configuration).getImportedList(requestParameters.search, requestParameters.includeAlreadyConnected, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WellpassApiGetTransactionHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WellpassApi
     */
    public getTransactionHistory(requestParameters: WellpassApiGetTransactionHistoryRequest, options?: AxiosRequestConfig) {
        return WellpassApiFp(this.configuration).getTransactionHistory(requestParameters.tenantId, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the wellpass company settings for a tenant
     * @param {WellpassApiGetWellpassConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WellpassApi
     */
    public getWellpassConfig(requestParameters: WellpassApiGetWellpassConfigRequest, options?: AxiosRequestConfig) {
        return WellpassApiFp(this.configuration).getWellpassConfig(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WellpassApiImportMembershipsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WellpassApi
     */
    public importMemberships(requestParameters: WellpassApiImportMembershipsRequest, options?: AxiosRequestConfig) {
        return WellpassApiFp(this.configuration).importMemberships(requestParameters.tenantId, requestParameters.importWellpassMembershipsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WellpassApiImportWellpassExcelListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WellpassApi
     */
    public importWellpassExcelList(requestParameters: WellpassApiImportWellpassExcelListRequest, options?: AxiosRequestConfig) {
        return WellpassApiFp(this.configuration).importWellpassExcelList(requestParameters.createWellpassImportDTO, requestParameters.dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WellpassApiSyncWellpassMembershipByTenantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WellpassApi
     */
    public syncWellpassMembershipByTenant(requestParameters: WellpassApiSyncWellpassMembershipByTenantRequest, options?: AxiosRequestConfig) {
        return WellpassApiFp(this.configuration).syncWellpassMembershipByTenant(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the settings for wellpass of a tenant
     * @param {WellpassApiUpdateWellpassSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WellpassApi
     */
    public updateWellpassSettings(requestParameters: WellpassApiUpdateWellpassSettingsRequest, options?: AxiosRequestConfig) {
        return WellpassApiFp(this.configuration).updateWellpassSettings(requestParameters.tenantId, requestParameters.updateWellpassSettingsDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
